import { createStore } from 'vuex';
import { notification } from './modules/notification';
import { chat } from './modules/chat';
import { stream } from './modules/stream';
import { app } from './modules/app';
import { admin } from './modules/admin';

export default createStore({
  modules: {
    notification,
    chat,
    app,
    stream,
    admin,
  },
});
